<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-05 16:08:53
 * @FilePath: \gcp-fe\src\app\shop\views\findPassword.vue
 * @Description: 通知公告与供应商找回密码----更多
-->
<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb
      class="bread-crumb"
      :currBreadCrumb="currBreadCrumb"
    ></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <div class="page-title">{{ $t("page.retrievePassword.title") }}</div>
        <el-divider></el-divider>
        <p class="section">
          {{ $t("page.retrievePassword.content1")
          }}<span
            class="red"
            style="cursor: pointer;"
            @click="download('10005451492', 'applytables.doc')"
            >{{ $t("page.retrievePassword.content2") }}</span
          >
          <button
            @click="download('10005451492', 'applytables.doc')"
            class="link-color tdu"
          >
            {{ $t("page.retrievePassword.downLoad") }}</button
          >{{ $t("page.retrievePassword.content3")
          }}<span style="color: #ff142f">{{
            $t("page.retrievePassword.content4")
          }}</span>
        </p>
        <el-divider></el-divider>
        <el-form
          :model="fromData"
          :rules="rules"
          ref="ruleForm"
          :validate-on-rule-change="false"
          class="ccui-form"
        >
          <el-form-item
            :label="$t('page.retrievePassword.supName')"
            prop="supName"
          >
            <el-col :span="8">
              <el-input
                v-model.trim="fromData.supName"
                :placeholder="$t('page.retrievePassword.holderSupName')"
                @blur="supNameCheckBlur"
              ></el-input>
            </el-col>
          </el-form-item>
          <p class="mb20">
            {{ $t("page.retrievePassword.hintContent1") }}
            <!-- <span class="red">{{
              $t("page.retrievePassword.hintContent2")
            }}</span> -->
          </p>
          <el-form-item
            :label="$t('page.retrievePassword.contactPerson')"
            prop="contactName"
            class="item-err2"
          >
            <el-col :span="8">
              <el-input
                v-model.trim="fromData.contactName"
                :placeholder="$t('page.retrievePassword.holderContactPerson')"
              ></el-input>
              <span class="ccui-ml-10">
                {{ $t("page.retrievePassword.hintContent5") }}
              </span>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('page.retrievePassword.mobilePhone')"
            prop="contactMobile"
            class="item-err3"
          >
            <el-col :span="8">
              <el-input
                v-model.trim="fromData.contactMobile"
                :placeholder="$t('page.retrievePassword.holderMobilePhone')"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-divider></el-divider>
          <p class="mb20">
            {{ $t("page.retrievePassword.hintContent3")
            }}<span class="red">{{
              $t("page.retrievePassword.hintContent4")
            }}</span>
          </p>
          <el-form-item
            :label="$t('page.retrievePassword.email')"
            prop="contactEmail"
          >
            <el-col :span="8">
              <el-input
                v-model.trim="fromData.contactEmail"
                :placeholder="$t('page.retrievePassword.holderEmail')"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('page.retrievePassword.verificationCode')"
            prop="contactCode"
          >
            <el-col :span="8" class="ver-code">
              <el-input
                v-model.trim="fromData.contactCode"
                :placeholder="
                  $t('page.retrievePassword.holderVerificationCode')
                "
              ></el-input
              ><span class="caCode">
                <!-- <el-input ref="tel" v-model="userInput" placeholder="请输入验证码" name="tel" type="text" tabindex="1" autocomplete="on" clearable /> -->
                <canvas
                  ref="canvas"
                  @click="createCode"
                  width="120"
                  height="50"
                ></canvas>
              </span>
            </el-col>
          </el-form-item>
          <el-table :data="fileData" align="center" border>
            <el-table-column
              prop="fileinfoTypeName"
              :label="$t('page.retrievePassword.fileinfoTypeName')"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="fileType"
              :label="$t('page.retrievePassword.fileType')"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.fileType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fileName"
              :label="$t('page.retrievePassword.fileName')"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              type="action"
              :label="$t('page.retrievePassword.operation')"
              :width="language == 'zh-cn' ? 200 : 500"
            >
              <template slot-scope="scope">
                <el-upload
                  :disabled="uploadDisabled"
                  class="uploadTabInlie"
                  :data="uploadData"
                  :action="uploadForm.action"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadSuccess"
                  :show-file-list="false"
                  :on-error="uploadError"
                  :on-progress="onProgress"
                  :headers="uploadForm.headers"
                  multiple
                >
                  <el-button
                    type="text"
                    @click="onUploadData(scope.$index, scope.row)"
                    >{{ $t("page.retrievePassword.upload") }}</el-button
                  >
                </el-upload>
                <!-- <el-button
                  v-else
                  type="text"
                  @click="onUploadData(scope.$index, scope.row)"
                  >上传</el-button
                > -->
                <el-button
                  type="text"
                  style="height: 36px; padding: 0;"
                  @click="deleteRow(scope.$index, scope.row)"
                  >{{ $t("page.retrievePassword.delete") }}</el-button
                >
                <el-button
                  v-if="scope.row.isShowDownload"
                  type="text"
                  style="height: 36px; padding: 0;"
                  @click="download('10005451492', 'applytables.doc')"
                  >{{
                    $t("page.retrievePassword.downloadSampleTable")
                  }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-form-item size="large" style="text-align:center;margin-top:20px;">
            <el-button type="primary" @click="onSubmit('ruleForm')">{{
              $t("page.retrievePassword.submit")
            }}</el-button>
            <el-button @click="resetForm('ruleForm')">{{
              $t("page.retrievePassword.reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import {
  dealSupplierFindPwd,
  checkSuppilerName
} from "@/app/shop/api/shopping";

export default {
  name: "retrievePassword",
  components: {
    baseBreadCrumb
  },
  data() {
    const checkCode = (rule, value, callback) => {
      if (value != this.codeStr) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      language: Cookies.get("language"),
      currBreadCrumb: [
        {
          title: this.$t("page.retrievePassword.retrievePassword")
        }
      ],
      codeStr: "", // 验证码字符串
      userInput: "", // 用户输入的验证码
      supNameCheckDate: false,
      uploadDisabled: true,
      fromData: {
        supName: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        contactCode: ""
      },
      index: "",
      code: "",
      uploadData: {},
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_SP_URL +
            "/apis/sp/smc/users/signup/uploadFilePersNew"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_SP_URL),
      rules: {
        supName: [
          {
            required: true,
            max: 100,
            message: this.$t("page.retrievePassword.holderSupName"),
            trigger: "blur"
          }
        ],
        contactMobile: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderMobilePhone"),
            trigger: "blur"
          },
          {
            pattern:
              Cookies.get("language") == "zh-cn"
                ? /^(\+)?(0|86|086|17951)?(-)?[0-9]{11}$/
                : "",
            message: this.$t("page.retrievePassword.effectiveMobile"),
            trigger: "blur"
          }
        ],
        contactName: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderContactPerson"),
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderEmail"),
            trigger: "blur"
          },
          {
            max: 100,
            // pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            pattern: /@/,
            message: this.$t("page.retrievePassword.effectiveEmail"),
            trigger: "blur"
          }
        ],
        contactCode: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderVerificationCode"),
            trigger: "blur"
          },
          {
            max: 4,
            required: true,
            validator: checkCode,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ]
      },
      fileData: [
        {
          billType: "906",
          fileinfoTypeName: this.$t("page.retrievePassword.fileinfoType1"),
          fileinfoType: "9061",
          fileType: this.$t("page.retrievePassword.fileTypeName"),
          fileName: "",
          fileSize: "",
          fileUrl: "",
          uploadTime: "",
          uploadId: "",
          isShowDownload: true
        },
        {
          billType: "906",
          fileinfoTypeName: this.$t("page.retrievePassword.fileinfoType2"),
          fileinfoType: "9062",
          fileType: this.$t("page.retrievePassword.fileTypeName"),
          fileName: "",
          fileSize: "",
          fileUrl: "",
          uploadTime: "",
          uploadId: ""
        }
      ]
    };
  },
  watch: {
    supNameCheckDate(valNew) {
      console.log(valNew);
      if (valNew === true) {
        checkSuppilerName({
          supplierName: this.fromData.supName
        })
          .then(res => {
            // debugger;
            if (this.fromData.supName != "") {
              this.code = true;
              // this.uploadData = {
              //   loginId: res.data.data.loginId,
              //   mobile: res.data.data.mobile,
              //   openId: res.data.data.openId,
              //   userId: res.data.data.userId
              // };
            } else {
              this.code = false;
              this.uploadDisabled = true;
              this.$message({
                message: res.data.message,
                type: "error",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.fromData.supName = "";
            }
          })
          .catch(err => {});
        this.$set(this, "supNameCheckDate", false);
      }
    }
  },
  activated() {
    console.log(Cookies.get("language"), "language");
    this.fromData.supName = "";
    this.fromData.contactName = "";
    this.fromData.contactMobile = "";
    this.fromData.contactEmail = "";
    this.fromData.contactCode = "";
    this.fileData.forEach(item => {
      item.fileName = "";
      item.fileSize = "";
      item.fileUrl = "";
      item.uploadTime = "";
      item.uploadId = "";
    });
    this.createCode();
  },
  deactivated() {},
  methods: {
    createCode() {
      const that = this;
      let codeLength = 4; // 验证码长度
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext("2d");
      let codeChars = "0123456789";
      let code = "";
      for (let i = 0; i < codeLength; i++) {
        let charIndex = Math.floor(Math.random() * codeChars.length);
        code += codeChars.charAt(charIndex);
      }
      this.codeStr = code;

      // 绘制验证码图片
      ctx.fillStyle = that.MathColor(180, 230);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = that.MathNumber(30, 40) + "px Arial";
      ctx.fillStyle = that.MathColor(80, 180);
      ctx.fillText(code, 20, 45);
      for (var i = 0; i < 6; i++) {
        ctx.strokeStyle = that.MathColor(0, 255);
        ctx.beginPath();
        ctx.moveTo(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height)
        );
        ctx.lineTo(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height)
        );
        ctx.stroke();
      }
      for (var y = 0; y < 50; y++) {
        // ctx.fillStyle = that.MathColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height),
          0.5,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
    //随机整数
    MathNumber(min, max) {
      var n = Math.floor(Math.random() * (max - min) + min);
      return n;
    },
    //随机颜色
    MathColor(min, max) {
      var r = this.MathNumber(min, max);
      var g = this.MathNumber(min, max);
      var b = this.MathNumber(min, max);
      return `rgb(${r},${g},${b})`;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    supNameCheckBlur() {
      if (this.fromData.supName) {
        this.$set(this, "supNameCheckDate", true);
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        var result = this.fileData.every(item => item.fileName !== "");
        if (valid && result && this.code) {
          // this.$confirm(
          //   "您的供应商密码取回申请提交成功，请注意查收邮件或短信",
          //   "提示",
          //   {
          //     confirmButtonText: "确定",
          //     showCancelButton: false,
          //     type: "success"
          //   }
          // ).then(res => {
          checkSuppilerName({
            supplierName: this.fromData.supName,
            isShowPageLoading: true
          }).then(res => {
            if (res.data.code == "0") {
              let fileDataList = this.fileData.map(v => {
                return {
                  billType: v.billType,
                  fileinfoType: v.fileinfoType,
                  fileUrl: v.fileUrl,
                  fileName: v.fileName,
                  fileSize: v.fileSize,
                  createTime: v.createTime,
                  fileIinfoType: v.fileIinfoType,
                  uploadId: v.uploadId
                };
              });
              console.log(fileDataList);
              let prmas = {
                operSource: this.isMobile ? 1 : 0,
                supName: this.fromData.supName,
                contactName: this.fromData.contactName,
                contactMobile: this.fromData.contactMobile,
                contactEmail: this.fromData.contactEmail,
                supFindPwdFileInfoBOList: fileDataList,
                isShowPageLoading: true
              };
              dealSupplierFindPwd(prmas).then(res => {
                this.$confirm(
                  this.$t("page.retrievePassword.confirmTitle1"),
                  this.$t("page.retrievePassword.confirmHint"),
                  {
                    confirmButtonText: this.$t(
                      "page.retrievePassword.ascertain"
                    ),
                    showCancelButton: false,
                    type: "success"
                  }
                )
                  .then(res => {
                    console.log(res);
                    this.fileData.forEach(item => {
                      item.fileName = "";
                      item.fileSize = "";
                      item.fileUrl = "";
                      item.uploadTime = "";
                      item.uploadId = "";
                    });
                    this.$router.back();
                  })
                  .catch(action => {
                    this.fileData.forEach(item => {
                      item.fileName = "";
                      item.fileSize = "";
                      item.fileUrl = "";
                      item.uploadTime = "";
                      item.uploadId = "";
                    });
                    this.$router.back();
                  });
              });
            }
          });

          // });
        } else {
          if (!result) {
            this.$confirm(
              this.$t("page.retrievePassword.confirmTitle2"),
              this.$t("page.retrievePassword.confirmHint"),
              {
                confirmButtonText: this.$t("page.retrievePassword.ascertain"),
                showCancelButton: false,
                type: "error"
              }
            );
          }
          return false;
        }
      });
    },
    resetForm(from) {
      this.fileData.forEach(item => {
        item.fileName = "";
        item.fileSize = "";
        item.fileUrl = "";
        item.uploadTime = "";
        item.uploadId = "";
      });
      this.$refs[from].resetFields();
    },
    uploadSuccess(res, file, fileList) {
      this.$message.success(this.$t("page.retrievePassword.fileSuccess"));
      this.uploadLoading = false;
      let fileData = res.data[0];
      console.log(fileData);
      let indexs = this.index;
      console.log(indexs);
      this.fileData.forEach((item, i, arr) => {
        arr[indexs].fileUrl = fileData.downloadUrl;
        arr[indexs].fileName = fileData.fileName;
        arr[indexs].fileSize = fileData.fileSize;
        arr[indexs].createTime = fileData.createTime;
        arr[indexs].fileIinfoType = fileData.fileType;
        arr[indexs].uploadId = fileData.uploadId;
      });
      console.log(this.fileData);
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: this.$t("page.retrievePassword.uploadError"),
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading = false;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = true;
    },
    onUploadData(index, row) {
      this.index = index;
      console.log(this.code);
      this.$refs["ruleForm"].validate(valid => {
        if (valid && this.code == true) {
          this.uploadDisabled = false;
        } else {
          this.uploadDisabled = true;
        }
      });
      if (this.uploadDisabled === true && this.code == false) {
        if (this.fromData.supName === "") {
          this.$confirm(
            this.$t("page.retrievePassword.confirmTitle3"),
            this.$t("page.retrievePassword.confirmHint"),
            {
              confirmButtonText: this.$t("page.retrievePassword.ascertain"),
              showCancelButton: false,
              type: "error"
            }
          );
        } else {
          this.$message({
            message: this.$t("page.retrievePassword.confirmTitle5"),
            type: "warning",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    },
    deleteRow(index, row) {
      row.fileName = "";
      row.fileSize = "";
      row.fileUrl = "";
      row.uploadTime = "";
      row.uploadId = "";
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let isUpload = true;
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "jfif" ||
        testmsg === "JFIF";
      this.fileData.forEach(item => {
        if (item.fileName === file.name) {
          isUpload = false;
          return this.$message.error(
            this.$t("page.retrievePassword.NoSameName")
          );
        }
      });
      if (!isLt50) {
        this.uploadLoading = false;
        this.$message({
          message: this.$t("page.retrievePassword.fileSizeNO50"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        isUpload = false;
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      if (!extension) {
        this.uploadLoading = false;
        this.$message({
          message: this.$t("page.retrievePassword.uploadBmpError"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        isUpload = false;
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension && isUpload;
    },
    download(uploadId, fileName) {
      if (this.baseUrl === "http://dev01-sp.iccec.cn") {
        uploadId = "10005451492";
      } else if (this.baseUrl === "http://test01-sp.iccec.cn") {
        uploadId = "10001013055";
      } else if (this.baseUrl === "http://uat01-sp.iccec.cn") {
        uploadId = "10005117155";
      }
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      console.log(uploadId);
      let zhUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202404/applytables.doc";
      let enUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202404/Forgot%20your%20username%20or%20password.doc";
      // openUrl.href = `${addUrlPerFix(
      //   process.env.VUE_APP_BASE_URL
      // )}/apis/sp/oss/downloadByUploadId?uploadId=${uploadId}`;
      if (Cookies.get("language") == "zh-cn") {
        openUrl.href = zhUrl;
      } else if (Cookies.get("language") == "en-gb") {
        openUrl.href = enUrl;
      }
      openUrl.setAttribute("download", fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style scoped lang="scss">
// src\config\styles\findPassword.scss
@import "@/config/styles/findPassword.scss";

.ver-code {
  position: relative;
}
.caCode {
  position: absolute;
  top: -10px;
  left: 105%;
  display: flex;
  height: 51px;
  // border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #333;
  margin-bottom: 22px;
  el-input {
    width: 60%;
  }
}
/deep/ .el-form-item__label {
  width: 200px;
}
// .item-err2  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
// .item-err3  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
// .item-err4  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
/deep/ .el-divider {
  background-color: transparent !important;
}
/deep/ .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  border-top: 1px dashed #ccc !important;
}
/deep/ .ccui-ml-10 {
  position: absolute;
  color: #ff142f;
}
.wrapper {
  margin-bottom: 20px;
}
.ccui-app-container-detail {
  min-height: calc(100vh - 190px);
  margin: 0px auto 0px !important;
  padding: 15px 0 15px;
  min-width: 1180px;
}
/deep/ .el-form-item__error {
  left: 205px;
}
.red {
  color: #ff142f;
}
.tdu {
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
}
.mb20 {
  margin-bottom: 20px;
}
.uploadTabInlie {
  display: inline-block;
  margin-right: 10px;
}
/deep/ .el-table--border td:first-child .cell::after {
  content: "*";
  color: #ff142f;
}
.bread-crumb {
  padding: 20px 0;
  margin: 0 !important;
}
.content .page-title {
  font-size: 16px;
  color: #4a4a4a;
  font-weight: 600;
  padding-top: 5px;
}
.section {
  font-size: 13px;
  text-indent: 2em;
  margin: 20px 0;
}
</style>
